import helper from "@/config/helper";
import Vue from "vue";

const toastrOptions = {
	position: "top",
};

const state = {
	list: [],

	opcaoCancelamento:	null,
	motivoCancelamento:	"",

	changeStatusAction:	null,
}

const actions = {
	getAllSubscriptions({ commit, rootGetters }, params){
		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",	credentials.email);
		data.append("code",		credentials.code);
		data.append("token",	credentials.token);
		data.append("method",	"getAllSubscriptions");

		if (params?.withoutLoading !== true) {
			commit("setLoading", true, { root: true });
		}

		helper
			.axios()
			.post("", data)
			.then((response) => {
				let data = response.data;

				if(data){
					commit("setSubscriptions", data);
				}
			})
			.catch((error) => {
				helper.callback_error(error);
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
			});
	},

	cancelarAssinatura({ commit, dispatch, state, rootState, rootGetters }){
		if(state.opcaoCancelamento == null || state.opcaoCancelamento == ""){
			Vue.$toast.warning("Selecione um motivo de cancelamento", toastrOptions);
			return;
		}

		if(
			state.opcaoCancelamento == 4 &&
			(state.motivoCancelamento == null || state.motivoCancelamento == "" || state.motivoCancelamento.length <= 10)
		){
			Vue.$toast.warning("Por favor, descreva o motivo do cancelamento", toastrOptions);
			return;
		}
		
		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",				credentials.email);
		data.append("code",					credentials.code);
		data.append("token",				credentials.token);
		data.append("merchant_number",		rootState.subscriptionDetail.merchant_number);
		data.append("subscription_id",		rootState.subscriptionDetail.subscription_id);
		data.append("opcao_cancelamento",	state.opcaoCancelamento);
		data.append("motivo_cancelamento",	state.motivoCancelamento);
		data.append("method",				"cancelSubscription");

		commit("setLoading", true, { root: true });

		helper
			.axios()
			.post("", data)
			.then(() => {
				Vue.$toast.success("Assinatura cancelada com sucesso.", toastrOptions);
			})
			.catch((error) => {
				helper.callback_error(error, "Falha ao cancelar a assinatura.");
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
				commit("setMotivoCancelamento", null);
				commit("setOpcaoCancelamento", null);
				commit("subscriptionDetail/setStatus", "3", { root: true });
				commit("modals/setDialogCancelSubscription", false, { root: true });
				dispatch ("analytics/setFeedback", "cancel_subscription", { root: true });
			});
	},

	changeStatus({ commit, dispatch, rootState, rootGetters }, action){
		commit("setLoading", true, { root: true });

		const credentials = rootGetters['auth/getCredentials'];

		let data = new FormData();
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("merchant_number",	rootState.subscriptionDetail.merchant_number);
		data.append("subscription_id",	rootState.subscriptionDetail.subscription_id);
		data.append("method",			"changeStatus");
		data.append("action",			action);

		helper
			.axios()
			.post("", data)
			.then((response) => {
				const data = response.data;
				switch(action){
					case "pauseSubscription":
						commit("subscriptionDetail/setStatus", "5",{ root: true });
						dispatch("analytics/setFeedback", "pause_subscription", { root: true });
						break;
					case "activateSubscription":
						commit("subscriptionDetail/setStatus", "1",{ root: true });
						dispatch("analytics/setFeedback", "activate_subscription", { root: true });
						break;
					case "skipBilling":
						commit("subscriptionDetail/setSkipped", "1", { root: true });
						dispatch("analytics/setFeedback", "skip_billing", { root: true });
						if(data.next_billing_date){
							commit("subscriptionDetail/setNextBillingDate", data.next_billing_date, { root: true });
						}
						break;
				}

				Vue.$toast.success("Operação realizada com sucesso", toastrOptions);
			})
			.catch((error) => {
				helper.callback_error(error, "Falha ao realizar a ação selecionada.");
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
				commit("modals/setDialogChangeStatus", false, { root: true });
			});
	}
}

const mutations = {
	setSubscriptions(state, content){
		state.list = content;
	},

	setOpcaoCancelamento(state, content){
		state.opcaoCancelamento = content;
	},

	setMotivoCancelamento(state, content){
		state.motivoCancelamento = content;
	},

	setChangeStatusAction(state, content){
		state.changeStatusAction = content;
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
